import { 
  RegisterUserModel, 
} from './user.model';

import { 
  BaseClass,
  dropProps,
} from '../../Base/base.class';

import { InputClass } from '../../Form/InputField/input.class';

import { InputModel } from '../../Form/InputField/input.model';

import { registerUserForm } from './user.data';

export class RegisterUserDataClass extends BaseClass<RegisterUserModel> implements RegisterUserModel {
  get email(): InputModel {
    return dropProps(this.props.email, new InputClass(this.props.email)); 
  }
  get password(): InputModel {
    return dropProps(this.props.password, new InputClass(this.props.password)); 
  }
  get passwordRepeat(): InputModel {
    return dropProps(this.props.passwordRepeat, new InputClass(this.props.passwordRepeat)); 
  }
}

export const registerUserFormValues = () => registerUserForm && dropProps<RegisterUserModel, RegisterUserDataClass>(
  registerUserForm(), 
  new RegisterUserDataClass(registerUserForm())
);